import { createFileRoute, redirect } from "@tanstack/react-router";

// 301 redirect: legacy URL → current canonical page
export const Route = createFileRoute("/voip-solutions")({
  beforeLoad: () => {
    throw redirect({ to: "/voip-montclair-ca", statusCode: 301 });
  },
});
